import { ignoreElements, take, tap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { track } from 'tracking/mixPanel'
import * as Actions from 'store/actions/index.ts'

const mapStateToMPEvent = (eventName) => {
  performance.mark('tsf-member-info-fetched')
  performance.measure('tsf-perf', 'tsf-start', 'tsf-member-info-fetched')
  const measures = performance.getEntriesByName('tsf-perf')
  const appLoadingTime = (measures && measures.length)
    ? Math.round(measures[measures.length - 1].duration)
    : 0

  return {
    'App Loading Time': appLoadingTime,
    'Event Name': eventName,
    'Interaction Type': 'Technical'
  }
}

const trackPerformancesEpic = (actions$) => actions$.pipe(
  ofType(Actions.member.MEMBER_INFO_FETCHED),
  take(1),
  tap(() => {
    if (performance && performance.mark && performance.measure) {
      const eventName = 'TSF Application Loaded'

      track(eventName, mapStateToMPEvent(eventName), { debug: !__PRODUCTION__ })
    }
  }),
  ignoreElements()
)

export default trackPerformancesEpic
